import DEFAULT_CONFIG from './settings.json';

const configElement = document.getElementById( 'config' );
export const Config = configElement ? JSON.parse(configElement.innerHTML) : DEFAULT_CONFIG
